module.exports = __webpack_public_path__ + "static/assets/35a4e9d5d1d81d5008b5dace8abd126b.svg";